/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionreasonforcancellation3Inputs */

const de__field_acquisitionreasonforcancellation3 = /** @type {(inputs: _Field_Acquisitionreasonforcancellation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund für Absage der Akquise`)
};

/**

* @param {_Field_Acquisitionreasonforcancellation3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionreasonforcancellation3 = /** @type {((inputs?: _Field_Acquisitionreasonforcancellation3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionreasonforcancellation3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionreasonforcancellation3(inputs)
});
export { _field_acquisitionreasonforcancellation3 as "_field_acquisitionReasonForCancellation" }